// extracted by mini-css-extract-plugin
module.exports = {"root":"bodyLayout_root__3Ocmn","textContainer":"bodyLayout_textContainer__3dAtu"};